module.exports = __webpack_public_path__ + "img/banner.1ac20af7.jpg";